import { mockData } from "./Mock"; 

// 买家列表mock数据
mockData.set("getBuyerList", [
    {
        id: 'B001',
        nickname: '张三',
        realName: '张三丰',
        type: 0,
        gender: 1,
        enterpriseName: '-',
        phone: '13800138001',
        status: 0,
        totalConsults: 50,
        totalOrders: 20,
        totalAmount: 50000,
        consultConversionRate: 0.4,
        level: 3,
        levelDesc: '黄金',
        wechat: 'zhangsan123',
        douyin: 'douyin123',
        isVerified: true,
        signatureUrl: 'https://example.com/signature1.png',
        blacklistRecords: [
            { type: 0, reason: '违规操作', timestamp: Date.now() - 30 * 24 * 60 * 60 * 1000 },
            { type: 1, reason: '整改完成', timestamp: Date.now() - 15 * 24 * 60 * 60 * 1000 }
        ],
        registerTime: Date.now() - 3600000 * 24 * 30
    },
    {
        id: 'B002',
        nickname: '阿里巴巴',
        realName: '马云',
        type: 1,
        gender: 1,
        enterpriseName: '阿里巴巴集团',
        phone: '13800138002',
        status: 0,
        totalConsults: 200,
        totalOrders: 100,
        totalAmount: 1000000,
        consultConversionRate: 0.5,
        level: 5,
        levelDesc: '黑曜',
        wechat: 'alibaba',
        douyin: 'alibaba_official',
        isVerified: true,
        signatureUrl: 'https://example.com/signature2.png',
        enterpriseBalance: 500000,
        blacklistRecords: [
            { type: 0, reason: '恶意投诉', timestamp: Date.now() - 10 * 24 * 60 * 60 * 1000 }
        ],
        registerTime: Date.now() - 3600000 * 24 * 60
    }
]); 